<template>
  <vs-popup
    title="Detalhes Pagamento Inconsistente"
    :active.sync="showModal"
    @close="closeModal"
  >
    <div v-if="item">
      <div class="vx-row mb-4">
        <!-- Situação -->
        <div class="vx-col lg:w-2/3">
          <span class="label">Situação</span>
          <div class="flex items-center">
            <span class="data mr-2">{{ item.situacao }}</span>
            <vs-chip v-if="item.deletedAt" color="danger" class="mt-2">
              Deletado
            </vs-chip>
            <vs-chip v-if="item.canceledAt" color="danger" class="mt-2">
              Cancelado
            </vs-chip>
          </div>
        </div>

        <!-- Nosso Numero -->
        <div class="vx-col lg:w-1/3">
          <span class="label">Nosso Número</span>
          <span>{{ item.nossoNumero }}</span>
        </div>
      </div>

      <div class="vx-row mb-4">
        <!-- Associado -->
        <div class="vx-col lg:w-2/3">
          <span class="label">Associado</span>
          <span>{{ item.idAssociado }} - {{ item.nomeAssociado }}</span>
        </div>

        <!-- CPF/CNPJ -->
        <div class="vx-col lg:w-1/3">
          <span class="label">CPF/CNPJ</span>
          <span>{{ item.cpfCnpj }}</span>
        </div>
      </div>

      <div class="vx-row mb-4">
        <!-- Valor -->
        <div class="vx-col lg:w-2/3">
          <span class="label">Valor</span>
          <p>{{ item.valor | currency }}</p>
        </div>

        <!-- Valor Pagamento -->
        <div class="vx-col lg:w-1/3">
          <span class="label">Valor Pagamento</span>
          <p>{{ item.valorPagamento | currency }}</p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <!-- Data Emissão -->
        <div class="vx-col lg:w-1/3">
          <span class="label">Data Emissão</span>
          <span>{{ item.dataEmissao | formatDate }}</span>
        </div>

        <!-- Data Vencimento -->
        <div class="vx-col lg:w-1/3">
          <span class="label">Data Vencimento</span>
          <span>{{ item.dataVencimento | formatDate }}</span>
        </div>

        <!-- Data Pagamento -->
        <div class="vx-col lg:w-1/3">
          <span class="label">Data Pagamento</span>
          <span>{{ item.dataPagamento | formatDate }}</span>
        </div>
      </div>

      <div class="vx-row">
        <!-- Banco -->
        <div class="vx-col lg:w-1/3">
          <span class="label">Banco</span>
          <span>{{ item.banco }}</span>
        </div>

        <!-- Agência -->
        <div class="vx-col lg:w-1/3">
          <span class="label">Agência</span>
          <span>{{ item.agencia }}</span>
        </div>

        <!-- Conta -->
        <div class="vx-col lg:w-1/3">
          <span class="label">Conta</span>
          <span>{{ item.conta }}</span>
        </div>
      </div>
      <div
        class="vx-col w-full mb-2"
        v-if="(item.deletedAt || item.canceledAt) && item.verificado"
      >
        <!-- Remove item.deletedAt e item.canceledAt -->
        <div class="flex flex-wrap gap-1 flex-row-reverse">
          <vs-button
            color="danger"
            data-test="reprocessar"
            @click="removerCanceladoRemovido()"
            >Reprocessar Boleto</vs-button
          >
        </div>
      </div>
      <span class="title">Análise Inconsistências</span>

      <div class="vx-row mb-8">
        <!-- Verificado -->
        <div class="vx-col lg:w-1/3 mb-4">
          <span class="label">Verificado</span>
          <vs-switch color="success" v-model="verificado" style="width: 60px">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>

        <!-- Data Verificação -->
        <div class="vx-col lg:w-1/3 mb-4">
          <span class="label">Data Verificação</span>
          <span v-if="item.verificado">
            {{ formatDateHour(item.dataUltimaVerificaaco) }}
          </span>
        </div>

        <!-- Usuário Verificação -->
        <div class="vx-col lg:w-1/3 mb-4">
          <span class="label">Usuário Verificação</span>
          <span v-if="item.verificado">{{ item.nomeUsuario }}</span>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" data-test="salvar" @click="submit">
            Salvar
          </vs-button>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import dateConversion from '../../../../utils/dateConversion';

export default {
  props: ['item'],
  data() {
    return {
      showModal: false,
      verificado: false,
      formatDateHour: dateConversion.convertISOToDateHour,
    };
  },
  watch: {
    item(value) {
      this.showModal = value ? true : false;

      if (value) {
        this.verificado = value.verificado;
      }
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.$emit('close');
    },
    removerCanceladoRemovido(){
      this.$emit('removerCanceladoRemovido', this.item);
    },
    submit() {
      this.$emit('sinalizaVerificado', this.verificado);
    },
  },
};
</script>

<style lang="scss">
span.label {
  display: block;
  font-weight: 700;
}

span.data {
  display: block;
}

span.title {
  display: block;
  font-size: 1.2rem;
  font-weight: 500;
  margin: 32px 0;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 8px 12px;
  color: #2c2c2c;
}
</style>
